// src/hooks/purchase/usePurchasePreviewHandler.ts
import { useState } from 'react';
import { useBasePurchase } from '../useBasePurchase';
import { usePurchasePreview } from './usePurchasePreview';
import { blobToBase64 } from '../../../utils/blobToBase64';
import { PreviewDocumentType } from '../../../types/pdf/PreviewDocumentType';

export const usePurchasePreviewHandler = () => {
  const [base64Pdf, setBase64Pdf] = useState<string | undefined>();
  const [fileName, setFileName] = useState<string>('documento.pdf');
  const { form } = useBasePurchase();
  const { fetchPdfBlob } = usePurchasePreview();

  /**
   * 📄 Genera o previsualiza el documento PDF de compra.
   * Mantiene la misma firma que el de ventas.
   */
  const handleViewDocument = async (selectedDoc: { id: number; code: string }) => {
    const purchaseId = form.id;
    const docType = selectedDoc.code as PreviewDocumentType;

    if (!purchaseId || !docType) {
      console.warn('⚠️ Falta el ID de la compra o el tipo de documento');
      return;
    }

    try {
      const result = await fetchPdfBlob(purchaseId, docType);
      if (result && result.blob) {
        const base64 = await blobToBase64(result.blob);
        setBase64Pdf(base64);

        // 📦 Asignar nombre dinámico si existe
        if (result.fileName) {
          setFileName(result.fileName);
        } else {
          // fallback seguro
          setFileName(`compra_${purchaseId}.pdf`);
        }
      } else {
        console.warn('⚠️ No se pudo obtener el PDF del servidor');
      }
    } catch (err) {
      console.error('❌ Error al generar el documento de compra:', err);
    }
  };

  return {
    base64Pdf,
    fileName, // ✅ se retorna también el nombre
    setBase64Pdf,
    handleViewDocument,
  };
};
